export default "__VITE_ASSET__CQGsEY3A__"